module.exports = __webpack_public_path__ + "static/media/lizAnimation3.41f9f540.gif";